import { QuestionType } from 'mobx-store/storeInterfaces/facilityFormInterface';
import { QuestionPreviewType } from 'mobx-store/storeInterfaces/surveyInterface';
import {
  BaseFormViewModel,
} from '../types';
import {
  FacilityDTO,
} from './facilityDTO';

export class FacilityFormViewModel extends BaseFormViewModel<FacilityDTO> {
  id: string;

  title: string;

  questions: any;

  availableCountries: Array<string>;

  deletedQuestionsIds: number [];

  constructor(dto: FacilityDTO) {
    super();
    const {
      id,
      title,
      questions,
      availableCountries,
      deletedQuestionsIds,
    } = dto;
    const questionPreview = questions
    .map((q: any) => {
      const val = {
        ...q,
        type: [q.type],
        questionPreview: [q.previewType || QuestionPreviewType.SINGLE_SELECT]
      };
      if (val.questionPreview === QuestionPreviewType.SELF_SELECT) {
        val.title = val?.questionOptions[0]?.text;
      }
      return val; 
    });
    Object.assign(this, {
      id,
      title,
      questions: questionPreview,
      availableCountries,
      deletedQuestionsIds,
    });
  }

  toDTO() {
    return this.questions.map((question: any) => question.type = question.type[0]);
  }
}
